<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Modal, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Spinner } from '@client/components/spinner';
  import { UserSelect } from '@client/components/user-select';

  import { GroupsService } from '@client/services/groups';

  const navigate = useNavigate();

  export let show = false;

  let records = [];
  let showRecords = false;
  let isFetching = false;
  let selectedUser = null;

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onClear();

      show = false;
    }
  };

  const onClear = () => {
    selectedUser = null;
    records = [];
    showRecords = false;
  };

  const findGroups = async () => {
    isFetching = true;
    showRecords = true;

    const response = await GroupsService.findGroupByEmail({
      email: selectedUser.value
    });

    if (response.status >= 400) {
      return;
    }

    records = response;

    isFetching = false;
  };
</script>

<Modal bind:isOpen={show} on:close={onClear} size="sm">
  <div class="diagnostics-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <div class="title">
        <h1>{$format('label.GROUP_DIAGNOSTICS')}</h1>
        <p>{$format('label.DESCRIPTION.GROUP_DIAGNOSTICS')}</p>
      </div>

      <div class="diagnostics-form">
        <div class="section">
          <div class="section-actions">
            <UserSelect
              placeholder={$format('label.PLACEHOLDER.SEARCH_USERS_DIAGNOSTICS')}
              bind:value={selectedUser}
              on:change={findGroups}
              on:clear={onClear}
            />
          </div>
        </div>

        {#if showRecords}
          <div class="section">
            <div class="section-info">{$format('label.MATCHES')}</div>
            <div class="section-actions {isFetching ? 'spinner' : 'records'}">
              {#if isFetching}
                <Spinner show inline />
              {:else}
                {#each records as record}
                  <div class="record-item">
                    <span class="group-name">
                      {record.groupname}
                      <!--
                        Prefixed differently from the card and table markers: this modal renders on
                        the groups page alongside the table, so a shared id would collide in the DOM
                        and point both tooltips at the same element.
                      -->
                      {#if record?.outlookaddin?.enableOverrides}
                        <span class="override" id="group-lookup-override-{record.groupname}">
                          <Icon name="signpost" size={14} />
                        </span>
                        <Tooltip target="group-lookup-override-{record.groupname}" placement="top">
                          {$format('label.ADDIN_OVERRIDES')}
                        </Tooltip>
                      {/if}
                    </span>
                    <Button color="primary" size="sm" on:click={() => navigate(`/manage/groups/${record.groupname}`)}>
                      {$format('label.VIEW_GROUP')}
                    </Button>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./diagnostics.scss"></style>
